import { build } from '@jackfranklin/test-data-bot'

import { type Base64File, type KybResponse, StakeholderRole } from './types'

const createMockBase64File = (filename: string): Base64File => ({
  base64content: 'mock-base64-content',
  mimetype: 'application/pdf',
  filename,
})

export const kybResponseBuilder = build<KybResponse>({
  fields: {
    steps: [
      {
        value: 'BUSINESS_DETAILS',
        label: 'Business details',
        status: 'DONE',
      },
      {
        value: 'ACCOUNT_REQUESTER_DETAILS',
        label: 'Account requester details',
        status: 'DONE',
      },
      {
        value: 'LEGAL_REPRESENTATIVE_DETAILS',
        label: 'Legal representative details',
        status: 'TODO',
      },
      {
        value: 'PRIMARY_BENEFICIAL_OWNER_DETAILS',
        label: 'Primary beneficial owner details',
        status: 'TODO',
      },
      {
        value: 'LETTER_OF_AUTHORIZATION',
        label: 'Letter of authorization',
        status: 'TODO',
      },
      {
        value: 'REVIEW',
        label: 'Review and submit',
        status: 'TODO',
      },
    ],
    data: {
      business: {
        legalName: 'Back Market Technologies SAS',
        tradeName: 'Back Market',
        email: 'info@backmarket.com',
        countryOfRegistration: 'FR',
        registrationType: 'SAS',
        registrationNumber: '123456789',
        incorporationDate: '2009-09-01',
        headquartersAddress: {
          addressLine1: '123 Main Street',
          addressLine2: 'Suite 456',
          postalCode: '75001',
          city: 'Paris',
          country: 'FR',
        },
        branchesAddresses: [
          {
            addressLine1: '123 Main Street',
            addressLine2: 'Suite 456',
            postalCode: '33000',
            city: 'Bordeaux',
            country: 'FR',
          },
        ],
        articleOfIncorporation: [],
        w9: [],
        registeredBusinessAddress: {
          addressLine1: '123 Main Street',
          addressLine2: 'Suite 456',
          postalCode: '75001',
          city: 'Paris',
          country: 'FR',
        },
        investedCapital: {
          currency: 'EUR',
          amount: 1000000,
        },
      },
      stakeholders: [
        {
          id: '123e4567-e89b-12d3-a456-426614174000',
          firstName: 'John',
          kanaFirstName: 'ジョン',
          latinFirstName: 'John',
          lastName: 'Doe',
          kanaLastName: 'ドウ',
          latinLastName: 'Doe',
          dateOfBirth: '1990-01-15',
          countryOfCitizenship: 'FR',
          phoneNumber: '+33123456789',
          countryOfResidency: 'FR',
          countryOfBirth: 'FR',
          address: {
            addressLine1: '123 Main Street',
            addressLine2: 'Suite 456',
            postalCode: '75001',
            city: 'Paris',
            country: 'FR',
          },
          identityDocument: {
            countryOfIssue: 'FR',
            front: createMockBase64File('id-front.pdf'),
            back: createMockBase64File('id-back.pdf'),
          },
          roles: [StakeholderRole.ACCOUNT_REQUESTER],
        },
        {
          id: '223e4567-e89b-12d3-a456-426614174001',
          firstName: 'Jane',
          kanaFirstName: 'ジェーン',
          latinFirstName: 'Jane',
          lastName: 'Smith',
          kanaLastName: 'スミス',
          latinLastName: 'Smith',
          dateOfBirth: '1985-03-20',
          countryOfCitizenship: 'FR',
          phoneNumber: '+33987654321',
          countryOfResidency: 'FR',
          countryOfBirth: 'FR',
          address: {
            addressLine1: '456 Other Street',
            postalCode: '69000',
            city: 'Lyon',
            country: 'FR',
          },
          identityDocument: {
            countryOfIssue: 'FR',
            front: createMockBase64File('legal-rep-front.pdf'),
            back: createMockBase64File('legal-rep-back.pdf'),
          },
          roles: [StakeholderRole.LEGAL_REPRESENTATIVE],
        },
        {
          id: '323e4567-e89b-12d3-a456-426614174002',
          firstName: 'Robert',
          lastName: 'Johnson',
          dateOfBirth: '1980-07-10',
          countryOfCitizenship: 'FR',
          phoneNumber: '+33111222333',
          countryOfResidency: 'FR',
          countryOfBirth: 'FR',
          address: {
            addressLine1: '789 Another Street',
            postalCode: '13000',
            city: 'Marseille',
            country: 'FR',
          },
          identityDocument: {
            identificationType: 'PASSPORT',
            countryOfIssue: 'FR',
            front: createMockBase64File('id-front.pdf'),
            back: createMockBase64File('id-back.pdf'),
          },
          roles: [StakeholderRole.PRIMARY_BENEFICIAL_OWNER],
        },
        {
          id: '423e4567-e89b-12d3-a456-426614174003',
          firstName: 'Maria',
          lastName: 'Garcia',
          dateOfBirth: '1992-11-25',
          countryOfCitizenship: 'ES',
          phoneNumber: '+34999888777',
          countryOfResidency: 'ES',
          countryOfBirth: 'ES',
          address: {
            addressLine1: '987 Madrid Street',
            postalCode: '28001',
            city: 'Madrid',
            country: 'ES',
          },
          identityDocument: {
            identificationType: 'PASSPORT',
            countryOfIssue: 'ES',
            front: createMockBase64File('id-front.pdf'),
            back: createMockBase64File('id-back.pdf'),
          },
          roles: [StakeholderRole.SECONDARY_BENEFICIAL_OWNER],
        },
      ],
      letterOfAuthorization: null,
    },
    errors: [],
  },
})
